import axios from "./axios-handler.service";
const BASE_URL = "/api/EstatisticaLead";

export interface ResultadoStatus {
  emProcesso: number;
  qualificacao: number;
  ganhos: number;
  perdas: number;
  erros: number;
  jaCadastrados: number;
  total: number;
}

export interface ResultadoMotivo {
  idMotivoLead: number;
  quantidade: number;
}

export interface ResultadoCanal {
  nomeCanal: string;
  quantidade: number;
}

export interface StatusResultadoPorEtapa {
  idStatusLead: number;
  quantidade: number;
}

export interface ResultadoPorEtapa {
  idEtapaLead: number;
  status: StatusResultadoPorEtapa[];
}

export interface ResultadoPorTipoLead {
  idTipoLead: number;
  quantidade: number;
}

export class EstatisticaLeadService {
  static async resultadoPorEtapa(
    data: Date,
    idTipoLead?: number,
    idCanalLead?: number
  ): Promise<ResultadoPorEtapa[]> {
    const response = await axios.get(`${BASE_URL}/resultadoPorEtapa`, {
      params: { data, idTipoLead, idCanalLead },
    });
    return response.data;
  }
  static async resultadoPorStatus(data: Date): Promise<ResultadoStatus[]> {
    const response = await axios.get(`${BASE_URL}/ResultadoPorStatus`, {
      params: { data },
    });
    return response.data;
  }

  static async listarResultadoMotivos(data: Date): Promise<ResultadoMotivo[]> {
    const response = await axios.get(`${BASE_URL}/ListarResultadoMotivos`, {
      params: { data },
    });
    return response.data;
  }

  static async listarResultadoCanais(data: Date): Promise<ResultadoCanal[]> {
    const response = await axios.get(`${BASE_URL}/ListarResultadoCanais`, {
      params: { data },
    });
    return response.data;
  }

  static async resultadoPorTipo(data: Date): Promise<ResultadoPorTipoLead[]> {
    const response = await axios.get(`${BASE_URL}/resultadoPorTipo`, {
      params: { data },
    });
    return response.data;
  }
}
